/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagesProcessedPerDayDto } from '../../models/pages-processed-per-day-dto';

export interface DashboardPagesProcessedPerDayGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardPagesProcessedPerDayGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardPagesProcessedPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PagesProcessedPerDayDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardPagesProcessedPerDayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PagesProcessedPerDayDto>>;
    })
  );
}

dashboardPagesProcessedPerDayGet$Plain.PATH = '/Dashboard/pages-processed-per-day';
